let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gPFqJ")).then(() => parcelRequire('5bops'));